export default __webpack_public_path__ + "03fc71f2fc004d3e2619614a1c2c5577.png";